import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import DetailsTabs from "./components/tabs";
import Button from "@material-ui/core/Button";
import Domain from "@material-ui/icons/Domain";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import DetailsInfo from "./components/info";
import { useAttendanceLocalDetails } from "../../../services/api-tansquery/attendance-local/details";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import { useAttendanceLocalDetailsStyles } from "./styles";


export default function AttendanceLocalDetails() {
    const history = useHistory();
    const { setBreadcrumbs } = useBreadcrumbs();
    const { slug } = useParams<{ slug: string }>();
    const { classes } = useAttendanceLocalDetailsStyles();
    const { data: attendanceLocal } = useAttendanceLocalDetails(slug);

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Locais de Atendimento",
                    path: "/locais-de-atendimento",
                    icon: Domain
                },
                {
                    label: "Informações",
                    path: "",
                }
            ]
        });
    }, [setBreadcrumbs]);

    return (
        <Box className={classes.root}>
            <Box>
                <Button
                    className={classes.backButton}
                    startIcon={<ChevronLeft />}
                    onClick={() => history.goBack()}
                >
                    Voltar
                </Button>
            </Box>
            <DetailsInfo attendanceLocal={attendanceLocal} />
            <DetailsTabs attendanceLocal={attendanceLocal} />
        </Box >
    );
}
